export { default } from './PageEventsCategory.vue'
